import set from 'lodash/set'
import { z } from 'zod'

export const learningItemPermissions = {
  edit: z.boolean(),
  edit_description: z.boolean(),
  edit_image: z.boolean(),
  assets_manage: z.boolean(),
  comment: z.boolean(),
  comment_delete_permanent: z.boolean(),
}

export const learningItemPermissionsParser = z.preprocess((o: any) => {
  const permissions = Object.fromEntries(Object.keys(learningItemPermissions).map((name) => [name, false]))
  for (const p of o || []) {
    set(permissions, p.replace(/^learning_item\./, ''), true)
  }
  return permissions
}, z.object(learningItemPermissions))
